export default __webpack_public_path__ + "static/media/alphabet-yellow-m.57de1c43.png";